import { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import { Link } from "react-router-dom";

export default function CallbackLeadsPage() {

  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  // SEARCH STATES
  const [searchId, setSearchId] = useState("");
  const [searchDate, setSearchDate] = useState("");

  // FETCH CALLBACK LEADS
  const fetchCallbackLeads = async () => {

    try {

      setLoading(true);

      const response = await axiosInstance.get(
        "/leads/disposition/Callback"
      );

      setLeads(response.data.data || []);

    } catch (error) {

      console.error(error);

    } finally {

      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCallbackLeads();
  }, []);

  // FILTER LEADS
  const filteredLeads = leads.filter((lead) => {

    // SEARCH BY ID
    const matchesId =
      lead.id.toString().includes(searchId);

    // SEARCH BY DATE
    const matchesDate =
      !searchDate ||
      (
        lead.callback_date &&
        new Date(lead.callback_date)
          .toISOString()
          .split("T")[0]
          .includes(searchDate)
      );

    return matchesId && matchesDate;
  });

  return (

    <div className="max-w-7xl mx-auto p-6">

      {/* HEADER */}
      <div className="mb-6">

        <h1 className="text-2xl font-bold text-slate-800">
          Callback Leads
        </h1>

        <p className="text-slate-500 mt-1">
          Total Callback Leads: {filteredLeads.length}
        </p>

      </div>

      {/* SEARCH SECTION */}
      <div className="mb-4 flex flex-col md:flex-row gap-3">

        {/* SEARCH BY ID */}
        <input
          type="text"
          placeholder="Search by ID..."
          value={searchId}
          onChange={(e) => setSearchId(e.target.value)}
          className="w-full md:w-80 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />

        {/* SEARCH BY DATE */}
        <input
          type="date"
          value={searchDate}
          onChange={(e) => setSearchDate(e.target.value)}
          className="px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />

      </div>

      {/* LOADING */}
      {loading ? (

        <div className="bg-white border rounded-2xl p-10 text-center">
          Loading...
        </div>

      ) : filteredLeads.length === 0 ? (

        <div className="bg-white border rounded-2xl p-10 text-center">
          No callback leads found
        </div>

      ) : (

        <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">

          <div className="overflow-x-auto">

            <table className="w-full text-sm">

              <thead className="bg-slate-50 border-b">

                <tr>

                  <th className="px-5 py-4 text-left">
                    ID
                  </th>

                  <th className="px-5 py-4 text-left">
                    Business Name
                  </th>

                  <th className="px-5 py-4 text-left">
                    Contact Name
                  </th>

                  <th className="px-5 py-4 text-left">
                    Phone
                  </th>

                  <th className="px-5 py-4 text-left">
                    Callback Reason
                  </th>

                  <th className="px-5 py-4 text-left">
                    Callback Date
                  </th>

                  <th className="px-5 py-4 text-left">
                    Status
                  </th>

                </tr>

              </thead>

              <tbody>

                {filteredLeads.map((lead) => (

                  <tr
                    key={lead.id}
                    className="border-b hover:bg-slate-50"
                  >

                    {/* ID */}
                    <td className="px-5 py-4">

                      <Link
                        to={`/callback-leads-details/${lead.id}`}
                        className="text-blue-600 font-semibold hover:underline"
                      >
                        #{lead.id}
                      </Link>

                    </td>

                    {/* BUSINESS NAME */}
                    <td className="px-5 py-4">
                      {lead.business_name}
                    </td>

                    {/* CONTACT NAME */}
                    <td className="px-5 py-4">
                      {lead.contact_name}
                    </td>

                    {/* PHONE */}
                    <td className="px-5 py-4">
                      {lead.business_phone}
                    </td>

                    {/* CALLBACK REASON */}
                    <td className="px-5 py-4">
                      {lead.agent_feedback}
                    </td>

                    {/* CALLBACK DATE */}
                    <td className="px-5 py-4">

                      {lead.callback_date
                        ? new Date(lead.callback_date)
                            .toISOString()
                            .split("T")[0]
                        : ""}

                    </td>

                    {/* STATUS */}
                    <td className="px-5 py-4">

                      <span className="px-3 py-1 rounded-full text-xs bg-yellow-100 text-yellow-700">

                        {lead.lead_disposition}

                      </span>

                    </td>

                  </tr>

                ))}

              </tbody>

            </table>

          </div>

        </div>

      )}

    </div>
  );
}